import {
  LIST_INFO_FINANCEIRAS_INIT,
  LIST_INFO_FINANCEIRAS_SUCCESS,
  CREATE_INFO_FINANCEIRAS_INIT,
  CREATE_INFO_FINANCEIRAS_SUCCESS,
  UPDATE_INFO_FINANCEIRAS_INIT,
  UPDATE_INFO_FINANCEIRAS_SUCCESS,
  DELETE_INFO_FINANCEIRAS_INIT,
  DELETE_INFO_FINANCEIRAS_SUCCESS,
  LIST_DRES_INIT,
  LIST_DRES_SUCCESS,
  INFO_FINANCEIRAS_ERROR_MSG,
  CLEAR_INFO_FINANCEIRAS
} from '../actionTypes';

export const listInfoFinanceirasInit = (data: any) => ({
  type: LIST_INFO_FINANCEIRAS_INIT,
  payload: data
});

export const listInfoFinanceirasSuccess = (data: any) => ({
  type: LIST_INFO_FINANCEIRAS_SUCCESS,
  payload: data
});

export const createInfoFinanceirasInit = (data: any) => ({
  type: CREATE_INFO_FINANCEIRAS_INIT,
  payload: data
});

export const createInfoFinanceirasSuccess = (data: any) => ({
  type: CREATE_INFO_FINANCEIRAS_SUCCESS,
  payload: data
});

export const updateInfoFinanceirasInit = (data: any) => ({
  type: UPDATE_INFO_FINANCEIRAS_INIT,
  payload: data
});

export const updateInfoFinanceirasSuccess = (data: any) => ({
  type: UPDATE_INFO_FINANCEIRAS_SUCCESS,
  payload: data
});

export const deleteInfoFinanceirasInit = (data: any) => ({
  type: DELETE_INFO_FINANCEIRAS_INIT,
  payload: data
});

export const deleteInfoFinanceirasSuccess = (data: any) => ({
  type: DELETE_INFO_FINANCEIRAS_SUCCESS,
  payload: data
});

export const listDresInit = () => ({
  type: LIST_DRES_INIT
});

export const listDresSuccess = (data: any) => ({
  type: LIST_DRES_SUCCESS,
  payload: data
});

export const infoFinanceirasErrorMsg = (data: any) => ({
  type: INFO_FINANCEIRAS_ERROR_MSG,
  payload: data
});

export const clearInfoFinanceiras = () => ({
  type: CLEAR_INFO_FINANCEIRAS
});
